import React, { useEffect, useRef } from 'react';
import { HiOutlineClock } from 'react-icons/hi';
import { useHelp } from '../context/useHelp';

const HelpWaitingPrompt = () => {
    const {
        continueWaitingOrientation,
        dismissOrientation,
        pauseWaitingOrientation,
        waiting,
    } = useHelp();
    const headingRef = useRef(null);
    const canContinue = waiting?.resumeMode === 'manual';

    useEffect(() => {
        headingRef.current?.focus({ preventScroll: true });
    }, [waiting?.waitingTitle]);

    if (!waiting) return null;

    return (
        <section
            aria-labelledby="help-tutorial-waiting-title"
            className="fixed bottom-4 right-4 z-40 w-[calc(100%-2rem)] max-w-md rounded-xl border border-indigo-200 bg-white p-5 shadow-2xl"
        >
            <div className="flex items-start gap-3">
                <span className="inline-flex h-10 w-10 flex-none items-center justify-center rounded-full bg-indigo-100 text-xl text-indigo-700" aria-hidden="true">
                    <HiOutlineClock />
                </span>
                <div className="min-w-0 flex-1">
                    <h2
                        ref={headingRef}
                        id="help-tutorial-waiting-title"
                        tabIndex="-1"
                        className="font-semibold text-text-primary focus:outline-none"
                    >
                        {waiting.waitingTitle}
                    </h2>
                    <p className="mt-1 text-sm leading-6 text-text-secondary-dark">
                        {waiting.waitingDescription}
                    </p>
                </div>
            </div>
            <div className="mt-4 flex flex-wrap items-center gap-2">
                {canContinue && (
                    <button
                        type="button"
                        onClick={continueWaitingOrientation}
                        className="inline-flex min-h-11 items-center justify-center rounded-lg bg-normative-blue px-4 py-2 font-semibold text-white hover:bg-indigo-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2"
                    >
                        Continue tutorial
                    </button>
                )}
                <button
                    type="button"
                    onClick={pauseWaitingOrientation}
                    className="inline-flex min-h-11 items-center justify-center rounded-lg px-3 py-2 text-sm font-medium text-text-secondary-dark hover:bg-gray-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2"
                >
                    Continue later
                </button>
                <button
                    type="button"
                    onClick={dismissOrientation}
                    className="inline-flex min-h-11 items-center justify-center rounded-lg px-3 py-2 text-sm font-medium text-text-secondary-reg hover:bg-red-50 hover:text-red-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2"
                >
                    End tutorial
                </button>
            </div>
        </section>
    );
};

export default HelpWaitingPrompt;
